<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 px-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-center" style="height: 31px">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="lightning"></b-icon>
              Risikobewertung{{ calcHeaderTitleAppendix }}
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <b-button
              variant="secondary"
              class="text-white"
              @click="createNewRecord"
              :disabled="false"
              v-if="
                !$route.path.endsWith('/allocationunits') &&
                  $route.params.rid == null &&
                  !$route.path.endsWith('/create') &&
                  ($root.$user.isPlaner || $root.$user.isAdmin)
              "
              size="sm"
              style="height: 31px; padding-top: 5px"
            >
              <b-icon icon="plus" variant="white" class="mr-1" style=""></b-icon>
              Erfassen
            </b-button>

            <b-button
              variant="secondary"
              class="text-white"
              to="/risks/allocationunits/create"
              :disabled="false"
              v-if="$route.path.endsWith('/allocationunits') && ($root.$user.isPlaner || $root.$user.isAdmin)"
              size="sm"
              style="height: 31px; padding-top: 6px"
              @click="$refs['collapse-risks'].$data.show = true"
            >
              <b-icon icon="plus" variant="white" class="mr-1" style=""></b-icon>
              Erfassen
            </b-button>
            <!---
            <b-dropdown
              size="sm"
              id="dropdown-right1"
              right
              text="Erfassen"
              variant="secondary"
              v-if="$route.path.endsWith('/allocationunits')"
            >
              <template #button-content>
                <b-icon icon="plus" variant="white" class="mr-1" style=""></b-icon>
                Erfassen
              </template>
              <b-dropdown-item to="/risks/allocationunits/create">Vergabeeinheiten</b-dropdown-item>
              <b-dropdown-item to="/risks/project/create">Projektrisiko</b-dropdown-item>
            </b-dropdown>--->
            <b-button
              variant="secondary"
              class="text-white ml-2"
              @click="saveRecordAndReturn"
              :disabled="(!AppState && !AppState.currentCnR) || !AppState.currentCnRIsDirty"
              v-if="
                ($root.$user.isPlaner || $root.$user.isAdmin) && ($route.params.rid || $route.path.endsWith('/create'))
              "
              size="sm"
              style="height: 31px; padding-top: 5px"
            >
              <b-icon icon="check2" variant="white" class="mr-1" style=""></b-icon>
              Speichern
            </b-button>
            <span
              class="btn btn-light ml-2 py-0 px-2"
              @click="$router.push($route.path.substring(0, $route.path.lastIndexOf('/'))).catch(() => {})"
              v-if="$route.path != '/risks/allocationunits' && $route.path != '/risks/project'"
            >
              <div>
                <b-icon icon="x" variant="dark" class="" style="padding-top: 1px; height: 26px; width: 26px"></b-icon>
              </div>
            </span>
            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="AppState.cnrSearchText"
                :class="{ 'bg-primary-light-3': AppState.cnrSearchText !== '' }"
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  :disabled="!isDeleteButtonEnabled"-->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              @click="toggleFilter"
              :disabled="selectedRows.length == 0 && !filterToggle"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- HELP ICON  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              href="https://www.bauvisor.de/chancen-risiken/"
              target="_blank"
            >
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="header px-4 pb-4 bg-white">
      <div class="shadow-muted-super" ref="CnRSummarySection" style="max-width: 1592px">
        <table class="w-100 bg-white">
          <tr class="border">
            <td class="px-2 py-1" colspan="8" v-b-toggle.collapse-risks>
              <small>Übersicht - Aktuelle Chancen & Risiken</small>
            </td>
            <td class="text-right pr-2">
              <b-button v-b-toggle.collapse-risks variant="white" size="sm">
                <span class="when-opened">
                  <b-icon icon="chevron-up" class="action-button" />
                </span>
                <span class="when-closed"><b-icon icon="chevron-down" class="action-button" /></span>
              </b-button>
            </td>
          </tr>
        </table>

        <b-collapse
          id="collapse-risks"
          ref="collapse-risks"
          :visible="isTabOpen"
          @shown="onToggleHeader"
          @hidden="onToggleHeader"
        >
          <b-overlay :show="isHeaderLoading" rounded="sm" spinner-variant="primary" variant="white" opacity="0.8">
            <table class="w-100 bg-white small">
              <tr>
                <td class="border-left" style="width: 200px"></td>
                <td style="width: 150px">
                  <div class="text-muted mt-2"><strong>Chancen</strong></div>
                </td>
                <td style="width: 150px" class="border-right text-muted text-right">
                  <div class="px-2 mr-3"><small>(prognoserelevant)</small></div>
                </td>
                <td style="width: 150px">
                  <div class="ml-3 text-muted mt-2"><strong>Risiken</strong></div>
                </td>
                <td style="width: 150px" class="border-right text-muted text-right">
                  <div class="px-2 mr-3"><small>(prognoserelevant)</small></div>
                </td>
                <td style="width: 150px">
                  <div class="ml-3 mt-2 text-muted"><strong>Gesamtrisiko</strong></div>
                </td>
                <td style="width: 150px" class="border-right text-muted text-right">
                  <div class="px-2 mr-3"><small>(prognoserelevant)</small></div>
                </td>
              </tr>
              <tr>
                <td class="border-left pl-2 text-muted"><strong>Vergabeeinheiten</strong></td>
                <td class="border-right">
                  <div class="bg-light ml-0 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalVEChancen, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalVEChancenP, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalVERisiken, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalVERisikenP, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.TotalVE, SettingsStore) }}
                    </strong>
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.TotalVEP, SettingsStore) }}
                    </strong>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="border-left pl-2 text-muted"><strong>Projekt</strong></td>
                <td class="border-right">
                  <div class="bg-light ml-0 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalProjectChancen, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalProjectChancenP, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalProjectRisiken, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    {{ $utils.formatCurrency(summary.TotalProjectRisikenP, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.TotalProject, SettingsStore) }}
                    </strong>
                  </div>
                </td>
                <td class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.TotalProjectP, SettingsStore) }}
                    </strong>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="border-left pl-2" style="border-top: 4px double #dee2e6"><strong>Gesamtrisiko</strong></td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-0 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{ $utils.formatCurrency(summary.TotalChancen, SettingsStore) }}
                  </div>
                </td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{ $utils.formatCurrency(summary.TotalChancenP, SettingsStore) }}
                  </div>
                </td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{ $utils.formatCurrency(summary.TotalRisiken, SettingsStore) }}
                  </div>
                </td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{ $utils.formatCurrency(summary.TotalRisikenP, SettingsStore) }}
                  </div>
                </td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.Total, SettingsStore) }}
                    </strong>
                  </div>
                </td>
                <td style="border-top: 4px double #dee2e6" class="border-right">
                  <div class="bg-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    <strong>
                      {{ $utils.formatCurrency(summary.TotalP, SettingsStore) }}
                    </strong>
                  </div>
                </td>
              </tr>
              <tr v-if="$route.params.id">
                <td class="border-left" style="height: 15px"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="border-right"></td>
              </tr>
              <!-- Allocation Unit "Button Row" -->
              <tr
                v-if="$route.path == '/risks/allocationunits/create' && !AppState.currentCnRVE"
                class="bg-primary-light border-top border-left border-right"
              >
                <td colspan="7" class="ml-3 py-2 px-2">
                  <!-- Button "Vergabeeinheit wählen" -->
                  <b-button
                    id="ve-select-button"
                    ref="ve-select-button"
                    size="sm"
                    variant="outline-primary"
                    @click="$bvModal.show('veSearchDialog')"
                    @blur="$root.$emit('bv::hide::tooltip', 've-select-button')"
                  >
                    Vergabeeinheit wählen
                  </b-button>

                  <b-tooltip
                    ref="validationTooltip"
                    target="ve-select-button"
                    placement="bottomright"
                    custom-class="ve-select-tooltip"
                    triggers="null"
                  >
                    Bitte wählen Sie eine Vergabeeinheit aus.
                  </b-tooltip>
                  {{ AppState.currentCnRVE }}
                </td>
              </tr>
              <!-- Allocation Unit Details Row 1" -->
              <tr v-if="$route.params.id || AppState.currentCnRVE" class="bg-light-2">
                <td class="border-top border-left pl-2 text-primary">
                  <strong>
                    {{ AppState.currentCnRVE ? AppState.currentCnRVE.Ordinal : '' }}
                    {{ AppState.currentCnRVE ? AppState.currentCnRVE.DisplayName : '' }}
                  </strong>
                  <!---
                  <b-button v-if="$route.params.rid" variant="outline-primary" size="sm" class="py-0 px-2 ml-2">
                    ...
                  </b-button> --->
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-0 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    <!-- {{ AppState.currentCnRVE }} -->
                    {{
                      AppState.currentCnRVE
                        ? $utils.formatCurrency(AppState.currentCnRVE.Chancen, SettingsStore)
                        : ' 0 €'
                    }}
                  </div>
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{
                      AppState.currentCnRVE
                        ? $utils.formatCurrency(AppState.currentCnRVE.ChancenPrognose, SettingsStore)
                        : ' 0 €'
                    }}
                  </div>
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{
                      AppState.currentCnRVE
                        ? $utils.formatCurrency(AppState.currentCnRVE.Risiken, SettingsStore)
                        : ' 0 €'
                    }}
                  </div>
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    {{
                      AppState.currentCnRVE
                        ? $utils.formatCurrency(AppState.currentCnRVE.RisikenPrognose, SettingsStore)
                        : ' 0 €'
                    }}
                  </div>
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    <strong>
                      {{
                        AppState.currentCnRVE
                          ? $utils.formatCurrency(
                              AppState.currentCnRVE.Risiken - AppState.currentCnRVE.Chancen,
                              SettingsStore
                            )
                          : ' 0 €'
                      }}
                    </strong>
                  </div>
                </td>
                <td class="border-top">
                  <div class="bg-primary-semi-light ml-3 py-1 px-2 mr-3 text-right mb-2 mt-2">
                    <strong>
                      {{
                        AppState.currentCnRVE
                          ? $utils.formatCurrency(
                              AppState.currentCnRVE.RisikenPrognose - AppState.currentCnRVE.ChancenPrognose,
                              SettingsStore
                            )
                          : ' 0 €'
                      }}
                    </strong>
                  </div>
                </td>
              </tr>
              <!-- Allocation Unit Details Row "VE Details""" -->
              <tr v-if="$route.params.id || AppState.currentCnRVE" class="bg-light-2">
                <td colspan="7" class="border-left border-right py-1 px-2 pr-3 pb-3">
                  <div class="row">
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Status</small></label>
                      <div class="bg-light p-1">
                        {{ AppState.currentCnRVE ? AppState.currentCnRVE.ProcessStatus : '' }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>VE-Budget</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.BudgetSaldo, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>LV-Preis</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.LVPreis, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Abweichung</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.LVPreisAbw, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Angebotspreis</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.ActiveQuoteAmount, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Abweichung</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE ? $utils.formatCurrency(AppState.currentCnRVE.APAbw, SettingsStore) : ''
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-2"></div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Aktiv</small></label>

                      <b-form-checkbox
                        v-model="CnRActive"
                        name="check-button"
                        switch
                        @change="updateCnRActiveFlag(AppState.currentCnRVE)"
                        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
                      />
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.AmountSaldo, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Nachtragsbudget</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.NachtragsBudget, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Abgerechnet</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.Invoiced, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Obligo</small></label>
                      <div class="bg-light p-1 text-right">
                        {{
                          AppState.currentCnRVE
                            ? $utils.formatCurrency(AppState.currentCnRVE.Obligo, SettingsStore)
                            : ''
                        }}
                      </div>
                    </div>
                    <!--
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
                      <div class="bg-primary-semi-light p-1 text-right">
                        {{ $utils.formatCurrency(AppState.currentCnRVE.AmountSaldo, SettingsStore) }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Nachtragsbudget</small></label>
                      <div class="bg-primary-semi-light p-1 text-right">
                        {{ $utils.formatCurrency(AppState.currentCnRVE.NachtragsBudget, SettingsStore) }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Abgerechnet</small></label>
                      <div class="bg-primary-semi-light p-1 text-right">
                        {{ $utils.formatCurrency(AppState.currentCnRVE.Invoiced, SettingsStore) }}
                      </div>
                    </div>
                    <div class="col">
                      <label class="text-muted d-block mb-1"><small>Obligo</small></label>
                      <div class="bg-primary-semi-light p-1 text-right">
                        {{ $utils.formatCurrency(AppState.currentCnRVE.Obligo, SettingsStore) }}
                      </div>
                    </div>-->
                  </div>
                  <!--
                  Details: Status, VE-Budget, LV-Preis, Abweichung, Angebotspreis, Abweichung, Gesamtauftrag,
                  Nachtragsbudget, Abgerechnet, Obligo, C/R-Aktiv
                  -->
                </td>
              </tr>
            </table>
          </b-overlay>
        </b-collapse>
        <b-modal
          id="veSearchDialog"
          title="Vergabeeinheit wählen"
          @show="loadAllocationUnitsIntoModal"
          @ok="
            AppState.currentCnRVE = {
              VeDbId: modalSelectedItem.DbId,
              Ordinal: modalSelectedItem.Ordinal,
              DisplayName: modalSelectedItem.DisplayName
            };
            $eventBus.$emit('CnRVE:changed', modalSelectedItem.DbId);
          "
        >
          <input
            placeholder="Suchbegriff eingeben..."
            type="search"
            class="form-control block mb-3"
            ref="veSearchField"
          />
          <b-overlay :show="isVeLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
            <b-list-group style="height: 500px; overflow-y: auto">
              <b-list-group-item
                href="#"
                :active="item.DbId == (modalSelectedItem && modalSelectedItem.DbId ? modalSelectedItem.DbId : null)"
                class="flex-column align-items-start"
                v-for="item in allocationUnits"
                :key="item.DbId"
                @click="modalSelectedItem = item"
                @dblclick.stop="modalSelectedItem = item"
              >
                {{ item.text }}
              </b-list-group-item>
            </b-list-group>
          </b-overlay>
        </b-modal>
      </div>
    </div>
    <b-nav tabs class="pl-2 bg-white inverted" v-if="!$route.path.endsWith('/create')">
      <b-nav-item
        to="/risks/allocationunits"
        v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
        style="padding-left: 16px"
      >
        Vergabeeinheiten
      </b-nav-item>
      <b-nav-item
        to="/risks/project"
        v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
      >
        Projekt
      </b-nav-item>
    </b-nav>

    <div
      :class="{ 'main-canvas': true, 'border-top': $route.path.endsWith('/create') }"
      style="height: calc(100vh - 105px); overflow: auto"
    >
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import SettingsStore from '@/store/Settings';
import RisksService from '@/service/RisksService';
import AppState from '@/store/App.js';
import AllocationUnitsService from '@/service/AllocationUnitsService';
export default {
  data() {
    return {
      isHeaderLoading: true,
      isVeLoading: true,
      summary: {},
      SettingsStore,
      AppState,
      Ordinal: '',
      DisplayName: '',
      modalSelectedItem: null,
      allocationUnits: [],
      searchText: '',
      selectedRows: [],
      filterToggle: false
    };
  },
  computed: {
    isTabOpen() {
      return localStorage.getItem('collapse-risks') == 'true' ? true : false;
    },
    calcHeaderTitleAppendix() {
      switch (this.$route.name) {
        case 'Chancen & Risiken ohne VE':
          return ' - Vergabeeinheit Chance/Risiko erfassen';
        case 'Chancen & Risiken Project Formular':
          return ' - Projektchance/-risiko erfassen';
        case 'Chancen & Risiken Formular':
          return ' - Vergabeeinheit Chance/Risiko erfassen';
        default:
          return '';
      }
    },
    CnRActive: {
      get() {
        if (AppState.currentCnRVE) return AppState.currentCnRVE.CnRActive;
        return false;
      },
      set(value) {
        AppState.currentCnRVE.CnRActive = value;
      }
    }
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      AppState.cnrSearchText = '';
      AppState.cnrSearchTextProject = '';
      AppState.cnrSearchTextVe = '';
      AppState.cnrSearchTextVeList = '';
    });
  },
  mounted() {},
  async activated() {
    const that = this;
    this.$eventBus.$on('CnR:rowsSelected', function(rows) {
      that.selectedRows = rows;
    });
    if (
      !AppState.currentCnRVE &&
      this.$route.path.startsWith('/risks/allocationunits/') &&
      this.$route.params &&
      this.$route.params.id
    )
      AppState.currentCnRVE = await RisksService.getVESummary(this.$route.params.id);
    this.loadHeaderSummay();
    this.$eventBus.$on('CnR:deleted', this.loadHeaderSummay);
    this.$eventBus.$on('CnR:showVEValidation', this.showVEValidation);
    this.$eventBus.$on('CnRVE:changed', this.loadHeaderSummay);
    this.$eventBus.$on('CnR:filterReset', state => (that.filterToggle = state));
  },
  deactivated() {
    //window.removeEventListener('resize', this.onWindowResize);
    this.$eventBus.$off('CnR:deleted', this.loadHeaderSummay);
    this.$eventBus.$off('CnR:showVEValidation', this.showVEValidation);
    this.$eventBus.$off('CnRVE:changed', this.loadHeaderSummay);
  },
  methods: {
    /*
    async onVeChanged(dbId) {
      //AppState.currentCnRVE = await RisksService.getVESummary(dbId);
    },*/
    async loadHeaderSummay() {
      this.isHeaderLoading = true;
      /*
      this.summary = await RisksService.getProjectSummary();
      if (AppState.currentCnRVE) AppState.currentCnRVE = await RisksService.getVESummary(AppState.currentCnRVE.VeDbId); // await RisksService.getVESummary(AppState.currentCnRVE.VeDbId);
      */
      const promise1 = RisksService.getProjectSummary();
      var promise2 = null;
      if (AppState.currentCnRVE) {
        promise2 = RisksService.getVESummary(AppState.currentCnRVE.VeDbId); // await RisksService.getVESummary(AppState.currentCnRVE.VeDbId);
      }

      Promise.all([promise1, promise2])
        .then(values => {
          this.summary = values[0];
          if (values[1]) AppState.currentCnRVE = values[1];
        })
        .finally(() => (this.isHeaderLoading = false));
    },
    onToggleHeader() {
      this.$eventBus.$emit('CnR:header:toggle');
    },
    createNewRecord() {
      this.$refs['collapse-risks'].$data.show = true;
      this.$router.push(this.$route.path + '/create');
    },

    saveRecordAndReturn() {
      this.$eventBus.$emit('form:risks:save');
    },
    async loadAllocationUnitsIntoModal() {
      const data = await AllocationUnitsService.getAllocationUnitsSimple();
      if (data && data.length > 0)
        this.allocationUnits = data.map(x => {
          x.text = x.Ordinal + ' ' + x.DisplayName;
          return x;
        });
      this.isVeLoading = false;
    },
    showVEValidation() {
      this.$root.$emit('bv::show::tooltip', 've-select-button');
      this.$refs['ve-select-button'].focus();
    },
    async updateCnRActiveFlag(item) {
      await RisksService.updateCnRActiveFlag(item);
      this.$eventBus.$emit('CnR:deleted');
    },
    toggleFilter() {
      this.filterToggle = !this.filterToggle;
      this.$eventBus.$emit('CnR:filter', this.filterToggle);
    }
  }
};
</script>
<style>
.page-header {
  border-bottom: none !important;
}
.ve-select-tooltip > .tooltip-inner {
  background-color: white !important;
  color: black;
  border: 1px solid #808080;
}
.ve-select-tooltip > .arrow::before {
  border-bottom-color: #808080;
}
</style>
